var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { withContext } from "../../componentWrappers";
import { t, Translate } from "../../I18N";
import { deleteEntities } from "../../Entities/actions/actions";
import * as metadataActions from "../actions/actions";
import { wrapDispatch } from "../../Multireducer";
import { advancedSort } from "../../utils/advancedSort";
import { ShareButton } from "../../Permissions/components/ShareButton";
import TemplateLabel from "../../Layout/TemplateLabel";
import SidePanel from "../../Layout/SidePanel";
import { Icon } from "../../UI";
import { NeedAuthorization } from "../../Auth";
import MetadataForm from "./MetadataForm";
import comonTemplate from "../helpers/comonTemplate";

const sortedTemplates = createSelector(
  (s) => s.templates,
  (templates) => {
    const _templates = templates ? templates.toJS() : [];
    return advancedSort(_templates, { property: 'name' });
  }
);

const commonTemplate = createSelector(sortedTemplates, (s) => s.entitiesSelected, comonTemplate);

class SelectMultiplePanel extends Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.delete = this.delete.bind(this);
    this.cancel = this.cancel.bind(this);
    this.save = this.save.bind(this);
    this.edit = this.edit.bind(this);
    this.changeTemplate = this.changeTemplate.bind(this);
  }

  close() {
    this.props.unselectAllDocuments();
    this.props.resetForm(this.props.formKey);
  }

  delete() {
    this.props.mainContext.confirm({
      accept: () => {
        this.props.deleteEntities(this.props.entitiesSelected.toJS());
      },
      title: 'Confirm',
      message: 'Confirm delete multiple items'
    });
  }

  metadataFieldModified(key) {
    return (
      !this.props.formState.metadata[key].pristine && (
      !this.props.formState.metadata[key].$form ||
      !this.props.formState.metadata[key].$form.pristine));

  }

  save(formValues) {
    const modifiedValues = { metadata: {} };
    const template = this.props.template.toJS();
    Object.keys(formValues.metadata).forEach((key) => {
      if (this.metadataFieldModified(key)) {
        modifiedValues.metadata[key] = formValues.metadata[key];
      }
    });

    if (template._id) {
      modifiedValues.template = template._id;
    }

    if (this.props.formState.icon && !this.props.formState.icon.pristine) {
      modifiedValues.icon = formValues.icon;
    }

    return this.props.
    multipleUpdate(this.props.entitiesSelected, modifiedValues).
    then((updatedEntities) => {
      this.props.updateEntities(updatedEntities);
      this.props.unselectAllDocuments();
      this.props.resetForm(this.props.formKey);
    });
  }

  changeTemplate(_formModel, template) {
    const updatedEntities = this.props.entitiesSelected.map((entity) =>
    entity.set('template', template)
    );
    this.props.updateSelectedEntities(updatedEntities);
  }

  cancel() {
    this.props.mainContext.confirm({
      accept: () => {
        this.props.resetForm(this.props.formKey);
      },
      title: 'Confirm',
      message: 'Discard changes'
    });
  }

  edit() {
    this.props.loadForm(this.props.formKey, this.props.template.toJS());
  }

  sharedIds() {
    return this.props.entitiesSelected.map((entity) => entity.get('sharedId'));
  }

  renderEditingForm() {
    const { formKey, thesauris } = this.props;

    return (/*#__PURE__*/
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx("div", { className: "alert alert-warning" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle", size: "2x" }), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Warning: you are editing multiple entities. Fields marked with a"), ' ', /*#__PURE__*/
      _jsx(Icon, { icon: "exclamation-triangle" }), ' ', /*#__PURE__*/
      _jsx(Translate, {}, void 0, "will be updated with the same value.")
      )
      ), /*#__PURE__*/
      _jsx(MetadataForm, {
        id: "multiEdit",
        model: formKey,
        onSubmit: this.save,
        thesauris: thesauris,
        template: this.props.template,
        changeTemplate: this.changeTemplate,
        multipleEdition: true }
      )
      ));

  }

  renderEditingButtons() {
    return (/*#__PURE__*/
      _jsx(NeedAuthorization, {
        roles: ['admin', 'editor'],
        orWriteAccessTo: this.props.entitiesSelected.toJS() }, void 0, /*#__PURE__*/

      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        onClick: this.cancel,
        className: "cancel-edit-metadata btn btn-default" }, void 0, /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Cancel'))
      ), /*#__PURE__*/
      _jsx("button", { type: "submit", form: "multiEdit", className: "btn btn-success" }, void 0, /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Save'))
      )
      )
      ));

  }

  renderListButtons() {
    return (/*#__PURE__*/
      _jsx(NeedAuthorization, {
        roles: ['admin', 'editor'],
        orWriteAccessTo: this.props.entitiesSelected.toJS() }, void 0, /*#__PURE__*/

      _jsx("div", { className: "btn-cluster" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", onClick: this.edit, className: "edit btn btn-default" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "pencil-alt" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Edit'))
      ), /*#__PURE__*/
      _jsx(ShareButton, { sharedIds: this.sharedIds(), storeKey: this.props.storeKey })
      ), /*#__PURE__*/
      _jsx("div", { className: "btn-cluster content-right" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "delete btn btn-danger", onClick: this.delete }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "trash-alt" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Delete'))
      )
      )
      ));

  }

  renderList() {
    const { entitiesSelected, getAndSelectDocument } = this.props;
    return (/*#__PURE__*/
      _jsx("ul", { className: "entities-list" }, void 0,
      entitiesSelected.map((entity, index) => {
        const onClick = getAndSelectDocument.bind(this, entity.get('sharedId'));
        return (/*#__PURE__*/
          _jsx("li", { onClick: onClick }, index, /*#__PURE__*/
          _jsx("span", { className: "entity-title" }, void 0,
          entity.get('title'), /*#__PURE__*/
          _jsx(TemplateLabel, { template: entity.get('template') })
          )
          ));

      })
      ));

  }

  render() {
    const { entitiesSelected, open, editing } = this.props;
    return (/*#__PURE__*/
      _jsx(SidePanel, { open: open, className: "multi-edit" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-header" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "check" }), ' ', /*#__PURE__*/
      _jsx("span", {}, void 0,
      entitiesSelected.size, " ", t('System', 'selected')
      ), /*#__PURE__*/
      _jsx("button", { type: "button", className: "closeSidepanel close-modal", onClick: this.close }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "times" })
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "sidepanel-body" }, void 0,
      !editing && this.renderList(),
      editing && this.renderEditingForm()
      ), /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0,
      !editing && this.renderListButtons(),
      editing && this.renderEditingButtons()
      )
      ));

  }
}

SelectMultiplePanel.defaultProps = {
  entitiesSelected: Immutable.fromJS([]),
  template: null,
  open: false,
  editing: false
};






















const mapStateToProps = (_state, props) => ({
  template: commonTemplate(props),
  open: props.entitiesSelected.size > 1,
  editing: Object.keys(props.state || {}).length > 0
});

function mapDispatchToProps(dispatch, props) {
  return bindActionCreators(
    {
      deleteEntities,
      loadForm: metadataActions.loadTemplate,
      resetForm: metadataActions.resetReduxForm,
      multipleUpdate: metadataActions.multipleUpdate
    },
    wrapDispatch(dispatch, props.storeKey)
  );
}

export { SelectMultiplePanel, mapStateToProps };

export default connect(mapStateToProps, mapDispatchToProps)(withContext(SelectMultiplePanel));